import { Box, Typography } from '@mui/material';
import { WD } from '../../../warningDashboard/warningTheme';
import { FIGURE, LEVEL_TONE, STATUS, SUNKEN_BG } from '../utils/constants';
import { fmtHours, remainingOf } from '../utils/hours';
import PlanForm from './PlanForm';
import EntryRow from './EntryRow';
import EntryForm from './EntryForm';

/**
 * What opens under a task in the drawer: the head's planned-hours form, then the time logged against it and the form to log more.
 * Which parts show follows `row.canPlan` / `canLog`; the server still decides.
 */
export default function TaskHours({ task, plan, row, idx, today, canLog, onChanged }) {
  const entries = plan ? idx.entriesByPlan.get(plan.hourId) || [] : [];

  return (
    <Box sx={{ mb: 1.5, p: 1.5, borderRadius: 2, bgcolor: SUNKEN_BG, display: 'grid', gap: 1.5 }}>
      {row.canPlan && <PlanForm task={task} plan={plan} personId={row.person.id} onChanged={onChanged} />}

      {plan && canLog && (
        <>
          <Box display="flex" alignItems="baseline" justifyContent="space-between">
            <Typography sx={{ fontSize: 12, fontWeight: 700, color: WD.ink }}>Time logged</Typography>
            <Typography sx={{ fontSize: 12, color: WD.inkMuted, ...FIGURE }}>
              {fmtHours(plan.logged)} of {fmtHours(plan.plannedHours)} · {fmtHours(remainingOf(plan))} left
            </Typography>
          </Box>

          {entries.length > 0 && (
            <Box sx={{ display: 'grid', gap: 0.75 }}>
              {entries.map((entry) => (
                <EntryRow key={entry.entryId} entry={entry} plan={plan} today={today} onChanged={onChanged} />
              ))}
            </Box>
          )}

          {task.status === STATUS.ON_HOLD ? (
            <Typography sx={{ fontSize: 12, color: LEVEL_TONE.atCapacity.text }}>On hold - time can be logged again once it resumes.</Typography>
          ) : (
            <EntryForm plan={plan} today={today} onChanged={onChanged} />
          )}
        </>
      )}

      {!plan && !row.canPlan && <Typography sx={{ fontSize: 12, color: WD.inkFaint }}>Time can be logged once a head sets hours for this task.</Typography>}
    </Box>
  );
}
